export default "__VITE_ASSET__B6Wupzb2__"